import React from "react";

import { useTranslation } from "react-i18next";

import Card from "react-bootstrap/Card";

import { useCurrentClient } from "../../context/Client";

const support: Record<string, { email: string; phone: string }> = {
  "center-parcs": {
    email: "support@futureforward.nl",
    phone: "+31 (0)418 63 96 31",
  },
  undefined: {
    email: "",
    phone: "",
  },
};

const Support: React.FC = () => {
  const { t } = useTranslation(["support"]);

  const client = useCurrentClient();
  const clientCode = client?.code;

  return (
    <div className="container-fluid p-4">
      <h4 className="mb-4">{t("support:title")}</h4>
      <Card className="col-xl-4 mb-3 p-3">
        {t("support:email")}
        {support[clientCode ?? "undefined"].email}
      </Card>
      <Card className="col-xl-4 mb-3 p-3">
        {t("support:phone")}
        {support[clientCode ?? "undefined"].phone}
      </Card>
    </div>
  );
};

export default Support;
